import { render, staticRenderFns } from "./TestingTab.vue?vue&type=template&id=ace7259c&scoped=true&"
import script from "./TestingTab.vue?vue&type=script&lang=js&"
export * from "./TestingTab.vue?vue&type=script&lang=js&"
import style0 from "./TestingTab.vue?vue&type=style&index=0&id=ace7259c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace7259c",
  null
  
)

export default component.exports